var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('b-badge',{staticClass:"mt-2",class:_vm.environmentName,attrs:{"pill":""}},[_vm._v(_vm._s(_vm.environmentDisplayName))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }